import {
    ImportMethod,
    ImportParameter,
    ParameterOut,
    ImportResult,
    ImportMessage,
    ImportProgression,
} from "./../models/Import";
import { PagingParams, PagedResults } from "@abaco/web-common/src/Paging";
import { HTTPClient } from "@abaco/web-common/src/HTTP";

export default class ImportApi {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    async getImportMethods(object_type_id: string, paging: PagingParams): Promise<PagedResults<ImportMethod>> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/services/import/${object_type_id}/imports`, {
            params: {
                offset: paging.offset,
                count: paging.count,
                only_active: true,
                sort: "+ds_import_method",
            },
        });

        return res.data;
    }

    async getParameters(object_type_id: string, import_method_id: string): Promise<ImportParameter[]> {
        const res = await this.http.get(
            `/sitiagri-rest-api/api_basic/v1/services/import/${object_type_id}/imports/${import_method_id}/parameters`,
            {
                params: {
                    offset: 0,
                    count: 300,
                    sort: "p_order",
                },
            }
        );

        return res.data.records;
    }

    private fakeData = false;

    async getImportMessages(
        object_type_id: string,
        import_method_id: string,
        import_id: number,
        paging: PagingParams
    ): Promise<PagedResults<ImportMessage>> {
        // if (!this.fakeData) {
            const res = await this.http.get(
                `/sitiagri-rest-api/api_basic/v1/services/import/${object_type_id}/imports/${import_method_id}/imports/${import_id}/logs`,
                {
                    params: {
                        offset: paging.offset,
                        count: paging.count,
                    },
                }
            );
            return res.data;
        // } else {
        //     console.log("WARNING: TEST VALUE");
        //     const testResult: PagedResults<ImportMessage> = {
        //         totalcount: 3,
        //         offset: 0,
        //         count: 3,
        //         records: [
        //             {
        //                 message: "Hello world, this is an info message",
        //                 code: "aaa",
        //                 id_imp_log: 0,
        //                 id_import: 0,
        //                 is_info: 1,
        //                 is_error: 0,
        //                 is_warning: 0,
        //             },
        //             {
        //                 message: "Hello world, this is an error message",
        //                 code: "aaa",
        //                 id_imp_log: 0,
        //                 id_import: 0,
        //                 is_info: 0,
        //                 is_error: 1,
        //                 is_warning: 0,
        //             },
        //             {
        //                 message: "Hello world, this is an warning message",
        //                 code: "aaa",
        //                 id_imp_log: 0,
        //                 id_import: 0,
        //                 is_info: 0,
        //                 is_error: 0,
        //                 is_warning: 1,
        //             },
        //         ],
        //     };
        //     return testResult;
        // }
    }

    async verifyImport(
        object_type_id: string,
        import_method_id: string,
        parameterValues: ParameterOut[],
        pk_cuaa: number | null,
        notes?: string
    ): Promise<ImportResult> {
        let paramsString = "";
        parameterValues.forEach((pv) => {
            if (pv.parameter_value) {
                paramsString = paramsString.concat(`${pv.parameter_name}=${pv.parameter_value}|`);
            }
        });
        if(pk_cuaa){
            paramsString = paramsString.concat(`SUBJECT_ID=${pk_cuaa.toString()}`);
        }
        const formData = new FormData();
        formData.append("params", paramsString);
        formData.append("object_type_id", object_type_id);
        formData.append("import_method_id", import_method_id);
        if (notes) {
            formData.append("notes", notes);
        }

        // if (!this.fakeData) {
            const res = await this.http.post(
                `/sitiagri-rest-api/api_basic/v1/services/import/${object_type_id}/imports/${import_method_id}/imports`,
                formData
            );
            return res.data;
        // } else {
        //     console.log("WARNING: TEST VALUE");
        //     await new Promise((resolve) => setTimeout(resolve, 1000));
        //     const testResult: ImportResult = {
        //         parameters: "aaa",
        //         notes: "aaa",
        //         subject_id: 0,
        //         fg_active: "aaa",
        //         fg_asynchronous: 1,
        //         cod_source: "aaa",
        //         sco_source: "aaa",
        //         imported_counter: 1,
        //         staging_table: "aaa",
        //         import_id: -1,
        //         request_date: new Date(),
        //         read_date: new Date(),
        //         update_date: null,
        //         user_id: "aaa",
        //         ds_source: "aaa",
        //         de_source: "aaa",
        //         fg_end_valid: "aaa",
        //         has_errors: 0,
        //         has_warnings: 0,
        //         has_info: 0,
        //         import_method_id: "COPIA_PLOTS_DA_A",
        //         ds_import_method: "Copia appezzamenti da altra campagna (ASINCRONO)",
        //         de_import_method: "aaa",
        //         fg_update_dossier: "aaa",
        //         fg_start_valid: "aaa",
        //         fg_move_dossier: "aaa",
        //         imports_in_progress: [],
        //     };
        //     return testResult;
        // }
    }

    async executeImport(object_type_id: string, import_method_id: string, import_id: number): Promise<ImportResult> {
        // if (!this.fakeData) {
            const res = await this.http.put(
                `/sitiagri-rest-api/api_basic/v1/services/import/${object_type_id}/imports/${import_method_id}/imports/${import_id}`
            );
            return res.data;
        // } else {
        //     console.log("WARNING: TEST VALUE");
        //     await new Promise((resolve) => setTimeout(resolve, 1000));
        //     const testResult: ImportResult = {
        //         parameters: "aaa",
        //         notes: "aaa",
        //         subject_id: 0,
        //         fg_active: "aaa",
        //         fg_asynchronous: 1,
        //         cod_source: "aaa",
        //         sco_source: "aaa",
        //         imported_counter: 1,
        //         staging_table: "aaa",
        //         import_id: 0,
        //         request_date: new Date(),
        //         read_date: new Date(),
        //         update_date: null,
        //         user_id: "aaa",
        //         ds_source: "aaa",
        //         de_source: "aaa",
        //         fg_end_valid: "aaa",
        //         has_errors: 0,
        //         has_warnings: 0,
        //         has_info: 1,
        //         import_method_id: "COPIA_PLOTS_DA_A",
        //         ds_import_method: "Copia appezzamenti da altra campagna (ASINCRONO)",
        //         de_import_method: "aaa",
        //         fg_update_dossier: "aaa",
        //         fg_start_valid: "aaa",
        //         fg_move_dossier: "aaa",
        //         imports_in_progress: [],
        //     };
        //     return testResult;
        // }
    }

    async getImportProgression(
        objectImportId: string,
        import_method_id: string,
        import_id: number
    ): Promise<ImportProgression> {
        // if (!this.fakeData) {
            const res = await this.http.get(
                `/sitiagri-rest-api/api_basic/v1/services/import/${objectImportId}/imports/${import_method_id}/imports/${import_id}`
            );
            return res.data;
        // } else {
        //     console.log("WARNING: TEST VALUE");
        //     await new Promise((resolve) => setTimeout(resolve, 1000));
        //     const testResult: ImportProgression = {
        //         parameters: "aaa",
        //         progress: [
        //             {
        //                 done: 0,
        //                 progr: 0,
        //                 ds_progr: "Copiando appezzamenti",
        //                 todo: 100,
        //                 status: "aaa",
        //             },
        //         ],
        //         notes: "aaa",
        //         fg_asynchronous: 1,
        //         import_method_id: "COPIA_PLOTS_DA_A",
        //         ds_import_method: "Copia appezzamenti da altra campagna (ASINCRONO)",
        //         cod_source: "aaa",
        //         sco_source: "aaa",
        //         fg_active: "aaa",
        //         fg_start_valid: "aaa",
        //         imports_in_progress: [],
        //         staging_table: "aaa",
        //         imported_counter: 1,
        //         subject_id: 0,
        //         user_id: "aaa",
        //         de_import_method: "aaa",
        //         fg_update_dossier: "aaa",
        //         fg_end_valid: "aaa",
        //         fg_move_dossier: "aaa",
        //         import_id: 0,
        //         request_date: 0,
        //         read_date: 0,
        //         update_date: null,
        //         ds_source: "aaa",
        //         de_source: "aaa",
        //         has_errors: 0,
        //         has_warnings: 0,
        //         has_info: 1,
        //     };
        //     return testResult;
        // }
    }
}
